import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import type { EmployeeManualOrder } from '@/api/employee-manual-order'

interface ManualOrderDeleteDialogProps {
  order: EmployeeManualOrder | null
  count?: number
  open: boolean
  isSubmitting?: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export function ManualOrderDeleteDialog({
  order,
  count = 1,
  open,
  isSubmitting = false,
  onOpenChange,
  onConfirm,
}: ManualOrderDeleteDialogProps) {
  const isBatch = order === null && count > 1

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[420px]">
        <DialogHeader>
          <DialogTitle>{isBatch ? '批量删除订单' : '删除订单'}</DialogTitle>
          <DialogDescription>
            删除后订单将从列表中移除，相关业绩也会被清除。此操作不可撤销。
          </DialogDescription>
        </DialogHeader>

        {order ? (
          <div className="rounded-md border bg-muted/30 p-4 text-sm">
            <div className="text-muted-foreground">订单号</div>
            <div className="font-mono font-medium">{order.order_id}</div>
            <div className="mt-3 text-muted-foreground">订单金额</div>
            <div className="text-xl font-bold">¥{order.pay_price.toFixed(2)}</div>
            <div className="mt-3 text-muted-foreground">收货人</div>
            <div>{order.real_name || '-'} {order.user_phone || ''}</div>
          </div>
        ) : (
          <div className="rounded-md border bg-muted/30 p-4 text-sm">
            <div className="text-muted-foreground">已选择订单数</div>
            <div className="text-xl font-bold">{count} 个</div>
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isSubmitting}>
            返回
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isSubmitting}>
            {isSubmitting ? '删除中...' : isBatch ? '确认批量删除' : '确认删除'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
